import { AppState } from '.'
import { createSelector } from '@ngrx/store'

const selectRouterState = (state: AppState) => state?.router

export const selectRouterStateUrl = createSelector(selectRouterState, (state) => state?.state.url)
